import { get, post } from '@/utils/request'
import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getLableList = data => post(`${riskApi}/risk/label/findLabelByPage`, data)

export const getLableDelete = data => get(`${riskApi}/risk/label/delLabel`, data)

export const getLableUpdate = data => post(`${riskApi}/risk/label/updateLabel`, data)

export const getLableAdd = data => post(`${riskApi}/risk/label/addLabel`, data)

export const userLabel = data => post(`${riskApi}/risk/userLabel/page`, data)

//规则
export const getLabelRule = data => post(`${riskApi}/risk/labelRule/page`, data)

export const addLabelRule = data => post(`${riskApi}/risk/labelRule/add`, data)

export const updateLabelRule = data => post(`${riskApi}/risk/labelRule/update`, data)

export const deleteLabelRule = data => post(`${riskApi}/risk/labelRule/batchDelete`, data)

export const findAllLabel = data => post(`${riskApi}/risk/label/findAllLabel`, data)

export const getRuleList = data => post(`${riskApi}/risk/rule/list`, data)
